var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "8_146",
    d: "M1033.17 1070.41L904.722 874.705L1176.02 700.309L1303.08 895.179L1033.17 1070.41Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "8_147",
    d: "M1232.91 1381.75L1233.7 1381.19L1233.17 1380.38L1149.22 1251.23L1421.5 1076.71L1558.08 1286.18L1269.14 1473.77L1216.7 1393.19L1232.91 1381.75Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "8_142",
    d: "M855.018 907.309L982.082 1102.18L710.13 1278.05L583.714 1081.71L855.018 907.309Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "8_141",
    d: "M981.995 1102.25L1100.84 1287.02L829.42 1461.95L709.717 1277.71L981.995 1102.25Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "8_140",
    d: "M964.943 1670.41L829.7 1462.24L1101.08 1286.88L1184 1410.49L1184.54 1411.29L1185.36 1410.78L1199.01 1402.31L1250.96 1485.62L964.943 1670.41Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "8_145",
    d: "M904.628 874.551L777.719 679.707L1049.02 505.309L1176.08 700.175L904.628 874.551Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "8_143",
    d: "M583.628 1081.55L456.719 886.707L728.018 712.309L855.08 907.175L583.628 1081.55Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "8_144",
    d: "M457.293 887.01L292.387 634.337L883.888 252.532L1049.08 505.177L457.293 887.01Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "8_133",
    d: "M2287.37 1635.43H2144.33V1313.43H2232.66H2386.33V1635.43H2287.37Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "8_134",
    d: "M2560.06 2021.43H2386.33V1313.43H2493.69H2680.33V2021.43H2560.06Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "8_135",
    d: "M2287.37 2021.43H2144.33V1699.43H2232.66H2386.33V2021.43H2287.37Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "8_136",
    d: "M2049.46 2021.43H1912.33V1699.43H1996.99H2144.33V2021.43H2049.46Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "8_137",
    d: "M1817.46 2021.43H1680.33V1699.43H1764.99H1912.33V2021.43H1817.46Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "8_138",
    d: "M1584.46 2021.43H1447.33V1699.43H1531.99H1679.33V2021.43H1584.46Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "8_139",
    d: "M1447.33 1699.51V2021.43H1352.46H1224.81C1202.14 2021.43 1181.05 2009.79 1168.97 1990.61L974.703 1682.23L1212.04 1527.32L1307.49 1674.47L1308.03 1675.31L1308.87 1674.77L1354.36 1645.6L1447.33 1699.51Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "8_132",
    d: "M2048.64 1635.43H1910.33V1313.43H1995.73H2144.33V1635.43H2048.64Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "8_131",
    d: "M1676.33 1404.93V1313.43H1761.73H1910.33V1635.43H1814.64H1676.33V1561.43V1560.43H1675.33H1642.83V1405.93H1675.33H1676.33V1404.93Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor8);
export default __webpack_public_path__ + "static/media/select_floor_8.ad2f806be1fa65ebec58f3efc6edb9b6.svg";
export { ForwardRef as ReactComponent };